import React, { memo } from 'react';
import * as Styled from './styled';

interface RuleBuilderItemButtonsBarProps {
  onSaveClick?: () => void;
  onCancelClick?: () => void;
}

function RuleBuilderItemButtonsBar({
  onSaveClick,
  onCancelClick,
}: RuleBuilderItemButtonsBarProps): JSX.Element {
  return (
    <Styled.RuleBuilderItemButtonsBar>
      <Styled.CommandButton onClick={onSaveClick} buttonType="primary">
        Save
      </Styled.CommandButton>
      <Styled.CommandButton onClick={onCancelClick} buttonType="secondary">
        Cancel
      </Styled.CommandButton>
    </Styled.RuleBuilderItemButtonsBar>
  );
}

export default memo(RuleBuilderItemButtonsBar);
